<p-dialog
  [(visible)]="display"
  [style]="{ width: '40vw' }"
  (onHide)="cancel()"
  [modal]="true"
  [header]="'Remove Skill: ' + skillName"
>
  <div *ngIf="errorMessages.length > 0" class="error-container">
    <p-messages severity="error">
      <ng-template pTemplate="content">
        <span class="p-message-icon pi pi-times-circle"></span>
        <span class="p-ml-2">Please correct the following errors:</span>
        <ul>
          <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
        </ul>
      </ng-template>
    </p-messages>
  </div>

  <div class="field field-required pt-3">
    <bpt-text-input
      [highlightAllOnFocus]="true"
      placeholder=""
      [multiLine]="true"
      id="removalReasonInput"
      label="Removal Reason"
      [(ngModel)]="removalReason"
      [required]="true"
    ></bpt-text-input>
  </div>

  <ng-template pTemplate="footer">
    <p-button
    appPreventDoubleClick
      label="Cancel"
      type="button"
      id="removalReasonCancelButton"
      styleClass="p-button-outlined"
      class="align-right"
      (debounceClick)="cancel()"
    ></p-button>
    <p-button
      appPreventDoubleClick
      label="Remove"
      type="submit"
      id="removalReasonConfirmButton"
      class="align-right"
      (debounceClick)="saveReason()"
    ></p-button>
  </ng-template>
</p-dialog>
